import { allBlockchainCoin } from '@/assets/static/currency-list'

export default {
    graphFromCase: {},
    myCasesVisibilityMenuSwitcher: false,
    casesActiveTab: '',
    casesTimeFilter: {
        from: null,
        to: null,
    },
    casesLoading: false,
    activeBlockchain: allBlockchainCoin,
}
